<template>
  <div id="app">
    <ExcelSheet  
    fileName="DailySalesRegisterReportExcel"
    :importData="importData" >
     
      <template v-slot:top>
       
        <div
        style="width:300px ;float:left; ">
        <universal-input 
        label="fromDate"
        v-model="centerFilter"
        :config="centerFilterConfig"
      >
      </universal-input>
    </div>
 
    <div style="width:300px ;float: left; padding-left:12px">
      <universal-input v-model="courseFromDate" :config="courseFromDateConfig"
        @input="handleCourseFromDateInput"></universal-input>
    </div>
      </template>

    </ExcelSheet>
   
  </div>
</template>

<script setup>
 
import  ExcelSheet   from '@/components/Excel/excelSheet.vue'

import { DailySalesRegisterReportExcel as showExcel } from '@/api/salesOrder'

import {ownCenterList} from '@/api/center'
import {fetchList as paymentMethodFetchList} from '@/api/paymentMethod'
 

import moment from '@/utils/moment'

import { ref, onMounted, computed, toRefs, watch , onBeforeMount } from 'vue'
import { autoResetRef } from '@vueuse/core'
import UniversalInput from '@/components/CRUD/UniversalInput'


let AllCenter = ''
let AllCenterArray = [{id : 0 , label : 'ALL'}]


const headerJSON = ref( [])
  const coachCenterList = ref([])
  const TempData = ref([])
  const importData = ref({})
 
  const centerFilter = ref(0)
  const centerFilterConfig = ref({
  name: 'centerFilter',
  label: 'Center',
  type: {
    name: 'autocomplete',
    items: coachCenterList.value,
  },
})

 
const courseFromDate = ref('')

const paymentMethodList = ref([])
const orderSalesList = ref([])
const border_1 = ref([])
const merge_1 = ref([])
const calcChain_1 = ref([])
const startingRowNumber = ref(5)
 

watch(centerFilter, newValue => {
  if (newValue) {
    console.log('watchcenterFilter' , newValue)
   headerJSON.value =  [
  { Info: 'Daily Sales Register Report - ' + AllCenterArray[AllCenterArray.findIndex(item=> item.id === newValue)].label , fs: 18 },
  { Info: 'Date : ' + courseFromDate.value ,fs: 16 },
  { Info: 'Print Date : ' + moment().format('YYYY-MM-DD HH:mm') ,  fs: 12  },
  { Info: '' }, // Empty row
  { Info: '' }, //  top header
  { Info: '' }, // button header
]

    callAPI({ CenterID: newValue, Thedate: courseFromDate.value })
 
  }
 
  else{
    centerFilter.value = 0 
   headerJSON.value =  [
    { Info: `Daily Sales Register Report - ${AllCenterArray[0].label}` , fs: 18 },
  { Info: 'Date : ' + courseFromDate.value ,fs: 16 },
  { Info: 'Print Date : ' + moment().format('YYYY-MM-DD HH:mm') ,  fs: 12  },
  { Info: '' }, // Empty row
  { Info: '' }, //  top header
  { Info: '' }, // button header
  
  ]


    callAPI({ CenterID: 0, Thedate: courseFromDate.value })

  }
 
}
)



watch(courseFromDate, newValue => {
 
  if (newValue) {
    console.log('watchcenterFilter')
    headerJSON.value =  [
  { Info: 'Daily Sales Register Report - ' + AllCenterArray[AllCenterArray.findIndex(item=> item.id === centerFilter.value)].label, fs: 18 },
  { Info: 'Date : ' +   moment(newValue).format('YYYY-MM-DD') ,fs: 16 },
  { Info: 'Print Date : ' + moment().format('YYYY-MM-DD HH:mm') ,  fs: 12  },
  { Info: '' }, // Empty row
  { Info: '' }, //  top header
  { Info: '' }, // button header
]

    callAPI({ CenterID: centerFilter.value, Thedate: newValue })
 
  }
}

)

// watch(paymentMethodList , newValue => {
//   if (newValue) {
//     console.log('paymentMethodList')
//     callAPI({ CenterID: centerFilter.value, Thedate: courseFromDate.value })
 
//   }
// })



 
const courseFromDateConfig = ref({
  propName: 'courseFromDate',
  label: 'From Date',
  toplabel: 'Select Course Date',
  type: {
    name: 'datepicker',
  },
})

const courseToDateConfig = ref({
  propName: 'courseToDate',
  label: 'To Date',
  toplabel: 'Select Course Date',
  type: {
    name: 'datepicker',
  },
})
 

 

 
 


onMounted(() => {
  // .subtract(0, 'days')
  courseFromDate.value =   moment().subtract(30, 'days').format('YYYY-MM-DD')

  headerJSON.value =  [
  { Info: 'Daily Sales Register Report - ALL' , fs: 18 },
  { Info: 'Date : ' + courseFromDate.value ,fs: 16 },
  { Info: 'Print Date : ' + moment().format('YYYY-MM-DD HH:mm') ,  fs: 12  },
  { Info: '' }, // Empty row
  { Info: '' }, //  top header
  { Info: '' }, // button header
]



  
coachCenterList.value.push({
          id: 0,
          label: 'ALL',
        })



    paymentMethodFetchList( {
      page: 0,
      limit: 0,
    }).then(response => {
      console.log('response',response)
      // const firstItem = response.data.items[0].id
     
      for (let index = 0; index < response.data.items.length; index += 1) {
          const item = response.data.items[index]
          if (item) {
     
            paymentMethodList.value.push({
              id: item.id,
              description: item.description,
            })
       
          }
        }
        console.log('paymentMethodList.value',paymentMethodList.value)


//  initLuckysheet()
ownCenterList().then(response => {
  console.log('response',response)
  // const firstItem = response.data.items[0].id
 
  for (let index = 0; index < response.data.items.length; index += 1) {
      const item = response.data.items[index]
      if (item) {
 
        coachCenterList.value.push({
          id: item.id,
          label: item.code,
        })
   
      }
    }
    console.log('coachCenterList.value',coachCenterList.value) 


    for (let index = 0; index < response.data.items.length; index += 1) {
      const item = response.data.items[index]
      if (item) {
 
        coachCenterList.value.push({
          id: item.id,
          label: item.code,
        })
      
      }
    }
    // console.log('coachCenterList.value', coachCenterList.value)

    if  ( coachCenterList.value.length > 2 ){
      AllCenter = 'ALL('
      console.log('coachCenterList.value[0].label1',coachCenterList.value[0].label)
 
      for (let index = 1; index < coachCenterList.value.length; index += 1) 
      {
        AllCenter +=  coachCenterList.value[index].label + ', ' 
        AllCenterArray.push({
          id: index,
          label: coachCenterList.value[index].label,
        })
      }
    
      AllCenter = AllCenter.slice(0, -2);
      AllCenter += ')'
      AllCenterArray[0].label = AllCenter
     
    }
console.log('AllCenterArray',AllCenterArray)

 

headerJSON.value =  [
  { Info: `Daily Sales Register Report - ${AllCenterArray[0].label}` , fs: 18 },
  { Info: 'Date : ' + courseFromDate.value ,fs: 16 },
  { Info: 'Print Date : ' + moment().format('YYYY-MM-DD HH:mm') ,  fs: 12  },
  { Info: '' }, // Empty row
  { Info: '' }, //  top header
  { Info: '' }, // button header
]


setTimeout(function() {
   
 
   centerFilter.value = false
}, 1500);


    }).catch(err => {  
      console.log('err',err)
      })
     })
 
  
     
     .catch(err => {  
      console.log('err',err)
      })



})

function handleCourseFromDateInput(dateValue) {
 console.log('dateValue',dateValue )
}

function handleCourseToDateInput(dateValue) {
  console.log('dateValue',dateValue )
}


function addBgToPreSecondLockerID(lockers) {
  let addColor = false // if true add color
  let tempID = 0
  try
  {
    tempID = lockers[0].lockerID;
  }catch
  {

  }
 
  for (let i = 0; i < lockers.length; i++) {
    

    if (i == 0)
    {

    }
    else{
       if (lockers[i].lockerID != tempID){
        addColor = !addColor
        tempID = lockers[i].lockerID 
       }


      if (addColor)
       lockers[i].bg = '#D9D9D9';
 
    }

 
  }
 
  return lockers;
}
 

function addBgToEverySecondRow(lockers) {
  for (let i = 0; i < lockers.length; i++) {
    if ((i%2) != 0)
       lockers[i].bg = '#D9D9D9';
  }
    
  return lockers;
}
 
function generateMergeJson(data, rowOffset, columnOffset) {
  const mergeJson = {};
  const mergeStart = {};
  const keysToMerge = ["lockerNo", "lockerSize", "lockerStatus" , "currentUser"];

  data.forEach((row, i) => {
    let lockerIdMatch = true;
    if (i === 0 || row["lockerID"] !== data[i - 1]["lockerID"]) {
      lockerIdMatch = false;
    }

    if (lockerIdMatch) {
      keysToMerge.forEach((key) => {
        mergeStart[key] = (mergeStart[key] || 0) + 1;
      });
    } else {
      keysToMerge.forEach((key, j) => {
        if (mergeStart[key] && mergeStart[key] > 1) {
          const mergeKey = `${i - mergeStart[key] + rowOffset}_${j + columnOffset}`;
          mergeJson[mergeKey] = {
            rs: mergeStart[key],
            cs: 1,
            r: i - mergeStart[key] + rowOffset,
            c: j + columnOffset,
          };
        }
        mergeStart[key] = 1;
      });
    }
  });

  keysToMerge.forEach((key, j) => {
    if (mergeStart[key] && mergeStart[key] > 1) {
      const mergeKey = `${data.length - mergeStart[key] + rowOffset}_${j + columnOffset}`;
      mergeJson[mergeKey] = {
        rs: mergeStart[key],
        cs: 1,
        r: data.length - mergeStart[key] + rowOffset,
        c: j + columnOffset,
      };
    }
  });

  return  mergeJson ;
}



function convertTimestamp(timestamp) {
  const momentObj = moment(timestamp);
  const formattedDate = momentObj.format('DD/MM/YYYY');
  const formattedTime = momentObj.format('hh:mm:ss A');

  return `${formattedDate} ${formattedTime}`;
}

function convertTransactionDates(json) {
  json.forEach(obj => {
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && moment(obj[key], moment.ISO_8601).isValid()) {
        const momentObj = moment(obj[key]);
        const formattedDate = momentObj.format('DD/MM/YYYY hh:mm:ss A');
        obj[key] = formattedDate;
      }
    }
  });
  return json;
}

function calculateColumnWidths(celldata) {
  const colWidths = {};

  celldata.forEach((cell) => {
    const { c, v } = cell;
    const content = v.v;
    const fontSize =    cell.v.fs ?  cell.v.fs  :  12
    // const width = content.toString().length * 10 * fontSize/10; // 10 is an approximate width per character
    // const width = content.toString().length *  fontSize /1.15;
    let width = 73
    if (content){
      width = content.toString().length * fontSize / 1.6
    }
  
    if (width){
      if (width <= 73) {
      width = 73
    }
   
    }
 

    if (!colWidths[c] || width > colWidths[c]) {
      colWidths[c] = width;
    }
  });
 
  return colWidths;
 
}


function  headerFirstRowFunction(item)
{

  const {currentRow , originalHeaders ,orderSalesNameList , headers  , merge , payMentDescriptions ,
     bottomheaderColor , topheaderColor , celldata}    = item

     console.log('headerFirstRowFunction',payMentDescriptions)
        //create header first
       const key = `${currentRow}_${0}`;  
        const obj = { rs: 1, cs: originalHeaders.length, r: currentRow  , c: 0};
        merge[key] = obj;
     
        //merge Amount Allocation 
        const key_2 = `${currentRow}_${originalHeaders.length}`;  
        const obj_2 = { rs: 1, cs: payMentDescriptions.length  , 
          r: currentRow  , c: originalHeaders.length  };
        merge[key_2] = obj_2;

        //merge ordersales
        const key_3 = `${currentRow}_${headers.length - orderSalesNameList.length}`;  
        const obj_3 = { rs: 1, cs: orderSalesNameList.length , 
          r: currentRow  , c: headers.length - orderSalesNameList.length  };
        merge[key_3] = obj_3;

console.log('headersheaders',headers)
        headers.forEach((header, c) => {

console.log('cccc',c)
if (c < originalHeaders.length   ){
  celldata.push({
  r: currentRow,
  c,
  v: { m: '', ct: { fa: 'General', t: 's' }, v: '' , bg :topheaderColor[0] , ht: 0 },
});

}
else if (c >= originalHeaders.length  &&  c < originalHeaders.length  + payMentDescriptions.length ){
 
  celldata.push({
  r: currentRow,
  c,
  v: { m: 'Amount Allocation', ct: { fa: 'General', t: 's' }, v: 'Amount Allocation' , bg :topheaderColor[1]  , fc: '#FFFFFF' , ht: 0},
});

}
else 
{
celldata.push({
  r: currentRow,
  c,
  v: { m: 'Commission Percentage', ct: { fa: 'General', t: 's' }, v: 'Commission Percentage' , bg :topheaderColor[2] 
  , fc: '#FFFFFF' , ht: 0
,
},
});

}

});

 
 
}


function headerSecondRowFunction(item){
  const {currentRow , originalHeaders ,orderSalesNameList , headers  , merge , payMentDescriptions ,
     bottomheaderColor , topheaderColor , celldata}    = item
  headers.forEach((header, c) => {
    
        if (c < originalHeaders.length  ){
          celldata.push({
          r: currentRow,
          c,
          v: { m: header, ct: { fa: 'General', t: 's' }, v: header , bg :bottomheaderColor[0] , fc: '#FFFFFF' },
        });
        // border =   [...border, ...generateBorder(row, row, c, c  , {style : 1})];
        }
        else if (c >= originalHeaders.length &&  c < originalHeaders.length + payMentDescriptions.length){
          celldata.push({
          r: currentRow,
          c,
          v: { m: header, ct: { fa: 'General', t: 's' }, v: header , bg :bottomheaderColor[1]  , fc: '#FFFFFF' },
        });
        // border =   [...border, ...generateBorder(row, row, c, c  , {style : 1})];
      }
      else
      { 
        celldata.push({
          r: currentRow,
          c,
          v: { m: header, ct: { fa: 'General', t: 's' }, v: header , bg :bottomheaderColor[2]  , fc: '#FFFFFF' },
        });
        // border =   [...border, ...generateBorder(row, row, c, c  , {style : 1})];

      }
      }
      );

}
 

function mainContent(items)
{ 

  let { currentRow , originalHeaders ,orderSalesNameList , headers  , merge , payMentDescriptions ,
     bottomheaderColor , topheaderColor , celldata , record  }    = items
 
            
     console.log('currentRowData',record)
      const currentRowData = [
        record.CenterCode,
        record.OrderNo,
        record.MembershipNo,
        record.MembershipName,
        record.Gender,
        record.HKID,
        record.Telephone,
        record.Email,
        record.EffectiveDate,
        record.ExpiryDate,
        record.Promotion,
        record.Course,
        record.Program,
        record.AmountPerSession,
        record.TotalAmount,
        record.SalesOrderPayment,
        record.OrderSalesmens,
        ];


        
        console.log('currentRowData',currentRowData)
 
        const CenterIndex = headers.indexOf('Center');
        const OrderNoIndex  = headers.indexOf('Order No');
        const MembershipNoIndex = headers.indexOf('Membership No');
        const NameIndex = headers.indexOf('Name');
        const GenderIndex = headers.indexOf('Gender');
        const HKIDIndex = headers.indexOf('HK ID');
        const TelephoneIndex = headers.indexOf('Telephone');
        const EmailIndex = headers.indexOf('Email');
        const EffectiveDateIndex = headers.indexOf('Effective Date');
        const ExpiryDateIndex = headers.indexOf('Expiry Date');
        const PromotionIndex = headers.indexOf('Promotion');
        const CourseIndex = headers.indexOf('Course');
        const ProgramIndex = headers.indexOf('Program');
        const TotalAmountIndex = headers.indexOf('Total Amount');
  
console.log('EffectiveDateIndex',EffectiveDateIndex)
console.log('ExpiryDateIndex',ExpiryDateIndex)

        currentRowData.forEach((value, c) => {
          
          if (c == 0){

            console.log('item.center',value)
          }

          if (c == EffectiveDateIndex || c == ExpiryDateIndex)
     {
      // console.log('c == 7 ||c == 8',value)
     
        
       const stringValue = value === undefined ? '' : new moment (value).format('MM/DD/YYYY');
       console.log('c == 7 ||c == 8typeof value',   stringValue)
      //Promotion
      const cell = {
          r: currentRow,
          c,
          v: {
            m:  stringValue, 
            ct: { fa: 'MM/dd/YYYY', t: 'd' },
            v:  stringValue ,  
            bg: record.bg ? record.bg : '#FFFFFF'
          },
        };
        celldata.push(cell);
      
      }

      else  if (c == PromotionIndex)
     {
      console.log('currentRowDatavalue',value)
       console.log('currentRowDatacc',c)

       const stringValue = value === undefined ? '' : value;

      //Promotion
      const cell = {
          r: currentRow,
          c,
          v: {
            m: (stringValue === '') ? '' :  stringValue.description,
            ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
            v:  (stringValue === '') ? '' :  stringValue.description,
            bg: record.bg ? record.bg : '#FFFFFF'
          },
        };
        celldata.push(cell);
      
      }
      else if (c == 15){
//SalesOrderPayment
console.log('SalesOrderPayment',value)
const test = paymentMethodList.value
let paymentMethodIDs = value.map(order => order.paymentMethodID);
let indices = paymentMethodIDs.map(id => test.findIndex(method => method.id === id));

// console.log('indices',indices); // This will output: [0, 2]
let counterPaymentColumn = 0 

test.forEach((paymentMethod, c) => {
 
  const isPresent  = indices.includes(c);
            if (isPresent == false){
              const cell = {
                        r: currentRow,
                        c : originalHeaders.length + c,
                        v: {
                          m: 0,
                          ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
                          v: 0,
                          bg: record.bg ? record.bg : '#FFFFFF'
                        },
                      };
                      celldata.push(cell);
            }
            else if (isPresent == true){
              const cell = {
                        r: currentRow,
                        c : originalHeaders.length + c,
                        v: {
                          m: value[counterPaymentColumn].amount,
                          ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
                          v: value[counterPaymentColumn].amount,
                          bg: record.bg ? record.bg : '#FFFFFF'
                        },
                      };
                      celldata.push(cell);
                      counterPaymentColumn +=  1
                  }
               
                });
       
     }


     else if (c == 16){
 
//Salesman
console.log(' ',value)
const test = orderSalesList.value
console.log('orderSalesList.value',orderSalesList.value)
let UserRecordIDs = value.map(order => order.userRecord.id);
let indices = UserRecordIDs.map(id => test.findIndex(user => user.id === id));

console.log('indices',indices); // This will output: [0, 2]
 let counterSalesManColumn = 0 
test.forEach((sales, c) => {
 console.log('c == 15', sales)
 const isPresent  = indices.includes(c);
           if (isPresent == false){
             const cell = {
                       r: currentRow,
                       c : originalHeaders.length +  payMentDescriptions.length + c,
                       v: {
                         m: '',
                         ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
                         v: '',
                         bg: record.bg ? record.bg: '#FFFFFF'
                       },
                     };
                     celldata.push(cell);
           }
           else if (isPresent == true){
             const cell = {
                       r: currentRow,
                       c : originalHeaders.length +  payMentDescriptions.length + c,
                       v: {
                         m: value[counterSalesManColumn].commissionPercentage.toString() + '%',
                         ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
                         v: value[counterSalesManColumn].commissionPercentage.toString() + '%',
                         bg: record.bg ? record.bg: '#FFFFFF'
                       },
                     };
                     celldata.push(cell);
                     counterSalesManColumn +=  1
                 }
              
               });
 
  
 
     }
     
     
     else{
      const stringValue = value === undefined ? '' : value;

//Promotion
const cell = {
    r: currentRow,
    c,
    v: {
      m: stringValue,
      // ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
      ct: { fa: 'General', t:  's' },
      v:  stringValue,
      ...(c === EmailIndex ) ? { ul: 1} : {},
      bg: record.bg ? record.bg : '#FFFFFF'
    },
  };
  celldata.push(cell);


     }
      
    
    })

  }


  function  totalFooter(  currentRow,  currentColumn  , originalHeaders , latestheaders , payMentDescriptionsLength, collectStartingRow,  {OrderTypeOffset = 0, nextRowOffset = 0, bg = '#0070C0', index = '0'}) {
  // const TotalValue = TheArrayValue.Total === undefined ? 0 : TheArrayValue.Total.toString();
  // const UnitValue = TheArrayValue.Unit === undefined ? 0 : TheArrayValue.Unit.toString();
 
  const index1 = originalHeaders.findIndex(theCell => theCell === 'Amount per Session')

  const index2 = latestheaders.length - payMentDescriptionsLength
  
  console.log( 'index1' , index1)
  console.log( 'index2' , index2)
const celldata = []
  for(let i = index1 ; i <= 1 +  index1 + payMentDescriptionsLength ; i++){
    if (i == index1)
    {
      const cell = {
      r:  currentRow,
      c:   i,
      v: {
        m: 'Total',
        ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
        v: 'Total',
      },
    };
    celldata.push(cell);


    }else
    {

     const theFunction = `=SUM(${createExcelColumnMap(i)}${collectStartingRow  }:${createExcelColumnMap(i)}${currentRow  })`
    //  const theFunction =  createExcelColumnMap(i)

      const cell = {
      r:  currentRow,
      c:   i,
      v: {
        f: theFunction,
        m: 0,
        ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
        v: 0,
        // bg: bg
      },
    };
    celldata.push(cell);
    const a = [
        {
          r: currentRow, //the number of rows
          c: i, //the number of columns
          index: index, //sheet id
          func: [true, 0, theFunction], //Formula information, including formula calculation results and formula string
          color: "w", //"w"：use Depth-First-Search "b":Normal search
          parent: null,
          chidren: {},
          times: 0
        },
      ]
      calcChain_1.value = [...calcChain_1.value, ...a]
   
      const b = generateBorder(currentRow, currentRow, i, i  , {style : 7 , left : false, right : false, top : false,})

      // console.log('border', generateBorder(currentRow, currentRow, i, i  , {style : 13 , left : false, right : false, top : false,}))
      border_1.value =   [...border_1.value, ...b]
      //  ...generateBorder(currentRow, currentRow, i, i  , {style : 13 , left : false, right : false, top : false,})];



  }
  
    }

 
 
return celldata
  }

  function footerContent(items){

let {  celldata , currentRow  , originalHeaders ,orderSalesNameList , 
  headers  , merge , payMentDescriptions  ,   topheaderColor , bottomheaderColor , contentRow  }   =   items


    const index = originalHeaders.findIndex(theCell => theCell === 'Amount per Session')
  const totalFooterResult = totalFooter(  currentRow ,index , originalHeaders , headers,  payMentDescriptions.length ,  contentRow[0] ,  {} )
  console.log('totalFooterResult',totalFooterResult)

  totalFooterResult.forEach((value, c) => {
    celldata.push(value)
  })
  }

 
  
  function grandContent(items){
 
let {  celldata , currentRow  , originalHeaders ,orderSalesNameList , 
  headers  , merge , payMentDescriptions  ,   topheaderColor , bottomheaderColor ,   sumTotalArray }   =   items


    const index = originalHeaders.findIndex(theCell => theCell === 'Amount per Session')
  const totalFooterResult = grandFooter(  currentRow ,index , originalHeaders , headers,  payMentDescriptions.length , sumTotalArray  ,  {} )
  console.log('grandFooterResult',totalFooterResult)

  totalFooterResult.forEach((value, c) => {
    celldata.push(value)
  })
  }

  function  grandFooter(  currentRow,  currentColumn  , originalHeaders , latestheaders , payMentDescriptionsLength, sumTotalArray ,  {OrderTypeOffset = 0, nextRowOffset = 0, bg = '#0070C0', index = '0'}) {
  // const TotalValue = TheArrayValue.Total === undefined ? 0 : TheArrayValue.Total.toString();
  // const UnitValue = TheArrayValue.Unit === undefined ? 0 : TheArrayValue.Unit.toString();
 
  const index1 = originalHeaders.findIndex(theCell => theCell === 'Amount per Session')

  const index2 = latestheaders.length - payMentDescriptionsLength
  
  console.log( 'index1' , index1)
  console.log( 'index2' , index2)
const celldata = []
  for(let i = index1 ; i <= 1 +  index1 + payMentDescriptionsLength ; i++){
    if (i == index1)
    {
      const cell = {
      r:  currentRow,
      c:   i,
      v: {
        m: 'Grand Total',
        ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
        v: 'Grand Total',
      },
    };
    celldata.push(cell);


    }else
    {

      let theFunction = '='
      sumTotalArray.forEach(pastRow  => {

      console.log('pastRow', pastRow)
      // theFunction = `=(${createExcelColumnMap(i)}${collectStartingRow  }:${createExcelColumnMap(i)}${currentRow  })`
      theFunction = theFunction +   `${createExcelColumnMap(i)}${pastRow}` +  '+'


      })

      theFunction = theFunction.slice(0, -1);
      // console.log('theFunction123',theFunction)
       
    //  const theFunction =  createExcelColumnMap(i)

      const cell = {
      r:  currentRow,
      c:   i,
      v: {
        f: theFunction,
        m: 0,
        ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
        v: 0,
        // bg: bg
      },
    };
    celldata.push(cell);
    const a = [
        {
          r: currentRow, //the number of rows
          c: i, //the number of columns
          index: index, //sheet id
          func: [true, 0, theFunction], //Formula information, including formula calculation results and formula string
          color: "w", //"w"：use Depth-First-Search "b":Normal search
          parent: null,
          chidren: {},
          times: 0
        },
      ]
  
      calcChain_1.value = [...calcChain_1.value, ...a]
   
      const b = generateBorder(currentRow, currentRow, i, i  , {style : 7 , left : false, right : false, top : false,})

      // console.log('border', generateBorder(currentRow, currentRow, i, i  , {style : 13 , left : false, right : false, top : false,}))
      border_1.value =   [...border_1.value, ...b]
      //  ...generateBorder(currentRow, currentRow, i, i  , {style : 13 , left : false, right : false, top : false,})];



  }
  
    }

 
 
return celldata
  }








function calculateColumnHeights(celldata) {
  const colHeights = {};

  celldata.forEach((cell) => {
    
    const { c, r } = cell;
    // const content = v.v;
    // const lines = content.toString().split(/\r\n|\r|\n/).length; // Count the number of lines in the content
    const fontSize =    cell.v.fs ?  cell.v.fs  :  12
    const lineHeight = fontSize * 1.2; // Calculate the line height based on the font size, assuming 1.2x the font size as a standard
    const height = lineHeight;

    if (!colHeights[r] || height > colHeights[r]) {
      colHeights[r] = height;
    }
  });

  return colHeights;
}

function  jsonToCelldata(jsonData , theGroupedData) {
 let merge = []
 let border = []
// console.log('jsonToCelldatatheGroupedData',theGroupedData)
    let headers =   [
                      'Center',
                      'Order No',
                      'Membership No',
                      'Name',
                      'Gender',
                      'HK ID',
                      'Telephone',
                      'Email',
                      'Effective Date',
                      'Expiry Date',
                      'Promotion',
                      'Course',
                      'Program',
                      'Amount per Session',
                      'Total Amount'
] ;
console.log('jsonData',jsonData)
const  originalHeaders = headers
let startHeader = false


const topheaderColor = ['#808080', '#ED7D31', '#375623']
const bottomheaderColor = ['#808080', '#C65911', '#375623']

const standardHeaderLength = headers.length
const payMentDescriptions = paymentMethodList.value.map(item => item.description);

console.log('paymentMethodList',paymentMethodList.value)
console.log('payMentDescriptions',payMentDescriptions)
const payMentDescriptionsLength = payMentDescriptions.length
const orderSalesLength = orderSalesList.value.length

const orderSalesNameList = getSalesmenFullNames(orderSalesList.value)

console.log('orderSalesNameList',orderSalesNameList)


console.log('payMentDescriptions',payMentDescriptions)

headers = [...headers , ...payMentDescriptions]
headers = [...headers , ...orderSalesNameList]
console.log('jsonData',jsonData)

let startingRow = startingRowNumber.value
let currentRow  = 4
let startingHeader = false

for (let index = 0; index < theGroupedData.length; index++) {
 
 
 
} 
 

  console.log('jsonData',jsonData)
  const celldata = [];
let finalRowNumber = 0

//Description header
  jsonData.forEach((item, row) => {
    if (row < 4) {
      //please check theitem.fs
      // const fs = value === undefined ? 12 : item.fs;
  
      const infoCell = {
        r: row,
        c: 0,
        v: { m: item.Info, ct: { fa: 'General', t: 's' }, v: item.Info , fs: item.fs ? item.fs : 12 },
      };
      celldata.push(infoCell);
    } 




  })





let finalRow = 0 ;
let theGroupedDataCounter = 0;
let sumTotalArray = [];
  
  theGroupedData.forEach((theRecord, row) => {
    theGroupedDataCounter ++
  headers = []
  headers = [...originalHeaders , ...payMentDescriptions]
    orderSalesList.value = uniqueSalesmen(theRecord);
    const orderSalesNameList = getSalesmenFullNames(orderSalesList.value)
    headers = [...headers , ...orderSalesNameList]
    currentRow ++ 
 
 let item = {  celldata , currentRow  , originalHeaders ,orderSalesNameList , 
  headers  , merge , payMentDescriptions  ,   topheaderColor , bottomheaderColor}
 
  headerFirstRowFunction(item)
  currentRow ++
 

 
  item = {  celldata , currentRow  , originalHeaders ,orderSalesNameList , 
  headers  , merge , payMentDescriptions  ,   topheaderColor , bottomheaderColor}
  headerSecondRowFunction(item)
  currentRow ++

  let contentRow = []
  theRecord.forEach((record, row) => {

    item = { record,    celldata , currentRow  , originalHeaders ,orderSalesNameList , 
  headers  , merge , payMentDescriptions  ,   topheaderColor , bottomheaderColor}
    mainContent(item)
   
    currentRow ++
    contentRow = [...contentRow ,  currentRow]
 
  })
 
  //footer
  item = { celldata , currentRow  , originalHeaders ,orderSalesNameList , 
  headers  , merge , payMentDescriptions  ,   topheaderColor , bottomheaderColor , contentRow }
  footerContent(item)
 


  // console.log('merge', item)
  currentRow ++
  sumTotalArray = [...sumTotalArray , currentRow ]

  if ( theGroupedDataCounter ==  theGroupedData.length){
    finalRow = currentRow
  }
 
  })

console.log('finalRow',finalRow)
if (theGroupedDataCounter != 0)
{
  console.log('sumTotalArray',sumTotalArray)
  //grandTotal
 let item = { celldata , currentRow  , originalHeaders ,orderSalesNameList , 
  headers  , merge , payMentDescriptions  ,   topheaderColor , bottomheaderColor , sumTotalArray }
  grandContent(item)

}

  merge_1.value = merge
return celldata
  }

   
 


function initLuckysheet(data , theGroupedData) {
  border_1.value = []
  console.log('Sheet loaded')
 
  const celldata = jsonToCelldata(data , theGroupedData);
  const colWidths =  calculateColumnWidths(celldata);
  console.log('initLuckysheetcolWidths',colWidths)
  const colHeights=  calculateColumnHeights(celldata);
  console.log('colHeights', colHeights);

  //  border_1.value = [...border_1.value , ...addBorderToManyCell(celldata , { minumumR : startingRowNumber.value - 1 })] 
 
   border_1.value =  [... addBorderToManyCell(celldata , { minumumR : startingRowNumber.value - 1  , color : '#E0E0E0' })  ,... border_1.value]
 console.log('calcChain_1',calcChain_1.value)
  
  var options = {
    container: 'luckysheet',
    title: 'Locker',
    lang: 'zh',
    // showsheetbar: false,
    // defaultColWidth : 'auto',
    showsheetbar: true,
    forceCalculation: true,
    data: [
      {
        name: 'Sheet1',
        status: 1,
        index: "0",
        celldata: celldata,
        calcChain: calcChain_1.value,
        config: {
         
    	// authority:{// 当前工作表的权限配置
      //   sheet: 1, // sheet表下标。
      //   hintText: "You can not edit any cell", // 弹窗提示的文字
      // },
        
            merge: merge_1.value, //merged cells
            rowlen:{}, //Table row height
       
            columnlen: colWidths,
             rowlen :colHeights, //Table row height
            // columnlen: {
            //       //自定义宽度
            //       0: "auto",
            //       1: 300,
            //       2: 300,
            //       3: 300,
            //       4: 300,
            //     },
            rowhidden:{}, //hidden rows
            colhidden:{}, //hidden columns
            borderInfo: border_1.value, //borders
        },
      }, 
      // {
      //   name: 'Sheet2',
      //   status: 1,
      //   celldata: celldata,
      //   config: {
         
    	// // authority:{// 当前工作表的权限配置
      // //   sheet: 1, // sheet表下标。
      // //   hintText: "You can not edit any cell", // 弹窗提示的文字
      // // },
        
      //       merge:{}, //merged cells
      //       rowlen:{}, //Table row height
      //       columnlen: colWidths,
      //       // columnlen: {
      //       //       //自定义宽度
      //       //       0: "auto",
      //       //       1: 300,
      //       //       2: 300,
      //       //       3: 300,
      //       //       4: 300,
      //       //     },
      //       rowhidden:{}, //hidden rows
      //       colhidden:{}, //hidden columns
      //       borderInfo:{}, //borders
      //   },
      // },
    ],
  };
 
 return options
  } 

  function createExcelColumnMap(n) {
  let columnLabel = '';
  let temp = n + 1;
  while (temp > 0) {
    let remainder = (temp - 1) % 26;
    columnLabel = String.fromCharCode(65 + remainder) + columnLabel;
    temp = Math.floor((temp - remainder) / 26);
  }
  return columnLabel;
}


function addBorderToManyCell(data ,   { minusRow = 1,   minumumR = 4   ,  style = "1",  color = '#000000'  }) {
 
  let smallestR = Infinity;
    let smallestC = Infinity;
 
    let largestR = -1;
    let largestC = -1;
 

    for (let item of data) {
        if (item.r > minumumR && item.r < smallestR) {
            smallestR = item.r;
           
        }
        
        if (item.r > largestR) {
            largestR = item.r;
          
        }
        
        if (item.c < smallestC) {
            smallestC = item.c;
      
        }

        if (item.c > largestC) {
            largestC = item.c;
       
        }
    }

   var borderInfo = [];
  
  borderInfo.push({
    "rangeType": "range",
    "borderType": "border-all",
    "style": style,
    "color":color,
    "range": [{
        "row": [smallestR, largestR - minusRow ],
        "column": [smallestC, largestC]
    }]
    });


 return borderInfo
 
}



function generateBorder(startRow, endRow, startCol, endCol, 
{ left =true, right = true, top = true , bottom = true,    style = 2, color = '#000000' , borderType = 'border-outside'} ) {

const borderStyle = {
  "style": style,
  "color": color
};

var borderInfo = [];
  
for (var col = startCol; col <= endCol; col++) {
 
  // borderInfo.push({
  //   "rangeType": "range",
  //   "borderType": borderType,
  //   "style": style,
  //   "color": color,
  //   "range": [{
  //     "row": [startRow, endRow],
  //     "column": [startCol, col]
  //   }]
  // })

 
  var borderInfo = [];
  let counter = 0;
  borderInfo.push({
      "rangeType": "cell",
      "value": {
        "row_index": startRow,
        "col_index": col,
        // "t": borderStyle,
        ...(top) ? { "t": borderStyle } : {}, // Add left border for the top-left cell
        ...(bottom) ? { "b": borderStyle } : {},
        ...(left) ? { "l": borderStyle } : {},
        ...(right) ? { "r": borderStyle } : {},
 
      }
    });

 
}
      return borderInfo;
}

 

  function uniqueSalesmen(array) {
    console.log('array',array)
    let userRecords = array.flatMap(order => order.OrderSalesmens.map(salesman => salesman.userRecord));

    // Remove duplicates
    const uniqueUserRecords = userRecords.reduce((accumulator, current) => {
        if (!accumulator.some(record => record.id === current.id)) {
            accumulator.push(current);
        }
        return accumulator;
    }, []);

    return uniqueUserRecords;
}

function getSalesmenFullNames(uniqueSalesmen) {
    return uniqueSalesmen.map(salesman => salesman.fullName);
}

 
  function callAPI(data){
    showExcel(data)
     .then(lockerExcelresponse => {
      // console.log('lockerExcelresponse',lockerExcelresponse)
      let newArray =  lockerExcelresponse.data.items;
      console.log('newArray1',newArray)

//       orderSalesList.value = uniqueSalesmen(newArray);
//  console.log('orderSalesList.value',orderSalesList.value)

 const groupedData = [];

for (const item of newArray) {
  const centerId = item.centerID;
  const group = groupedData.find((group) => group.centerID === centerId);
  if (group) {
    group.items.push(item);
  } else {
    groupedData.push({ centerID: centerId, items: [item] });
  }
}

// Printing the grouped data
for (const group of groupedData) {
  console.log(`Center ID: ${group.centerID}`);
  for (const item of group.items) {
    console.log(item);
  }
  console.log();
}

//create a forloop for the groupedData 


     console.log('groupedData',groupedData)
let theGroupedData = []
for (const group of groupedData) {

console.log('inside' ,group)
const tempItem = group.items.map(item => ({
    "OrderNo": item.orderNo,
    "MembershipNo": item.userRecord.userNo,
    "MembershipName": item.userRecord.fullName,
    "Gender": item.userRecord.gender,
    "HKID": item.userRecord.hkid,
    "Telephone": item.userRecord.mobileNo,
    "Email": item.userRecord.email,
    "EffectiveDate": item.effectiveDate,
    "ExpiryDate": item.expiryDate,
    "Promotion": item.promotion,
    "Course": item.course.courseName,
    "Program": item.sessionTotal,
    "AmountPerSession": item.pricePerSession,
    "TotalAmount": item.totalAmount , 
    "OrderSalesmens": item.orderSalesmens,
    "SalesOrderPayment": item.salesOrderPayment,
    "CenterCode": item.center.code,
}));
 
theGroupedData.push(tempItem);
}
console.log('theGroupedData', theGroupedData);

       newArray = newArray.map(item => ({
    "OrderNo": item.orderNo,
    "MembershipNo": item.userRecord.userNo,
    "MembershipName": item.userRecord.fullName,
    "Gender": item.userRecord.gender,
    "HKID": item.userRecord.hkid,
    "Telephone": item.userRecord.mobileNo,
    "Email": item.userRecord.email,
    "EffectiveDate": item.effectiveDate,
    "ExpiryDate": item.expiryDate,
    "Promotion": item.promotion,
    "Course": item.course.courseName,
    "Program": item.sessionTotal,
    "AmountPerSession": item.pricePerSession,
    "TotalAmount": item.totalAmount , 
    "OrderSalesmens": item.orderSalesmens,
    "SalesOrderPayment": item.salesOrderPayment,
    "CenterCode": item.center.code,
  
}));

console.log('aftermap',newArray)
      newArray = addBgToEverySecondRow(newArray)
      // console.log('addBgToEverySecondRow',newArray)
 
      // TempData.value =   [...headerJSON.value, ...newArray];
      TempData.value =   [...headerJSON.value,  ...newArray];
    //  console.log('TempData.value',TempData.value)
 

    const temp =  initLuckysheet(TempData.value , theGroupedData)
    console.log('temp',temp)
    importData.value = temp

      
    // initLuckysheet(newValue)
     })
     
     .catch(err => {  
      console.log('err',err)
      })
  }
 


 
</script>